import { McIcon } from "./icon.js";

const SVG_NS = "http://www.w3.org/2000/svg";

const svgdefault = document.createElementNS(SVG_NS, "svg");
svgdefault.setAttribute("viewBox", "0 0 24 24");
svgdefault.setAttribute("fill", "none");
svgdefault.setAttribute("width", "24");
svgdefault.setAttribute("height", "24");

svgdefault.innerHTML = `
  <g stroke-width="0"></g>
  <g stroke-linecap="round" stroke-linejoin="round"></g>
  <g>
    <path
      d="M9.10745 2.67414C9.98414 2.24187 10.9649 2 12 2C15.7274 2 18.7491 5.13623 18.7491 9.00497V9.70957C18.7491 10.5552 18.9903 11.3818 19.4422 12.0854L20.5496 13.8095C21.5612 15.3843 20.789 17.5249 19.0296 18.0229C14.4273 19.3257 9.57274 19.3257 4.97036 18.0229C3.21105 17.5249 2.43882 15.3843 3.45036 13.8095L4.5578 12.0854C5.00972 11.3818 5.25087 10.5552 5.25087 9.70957V9.00497C5.25087 7.93058 5.48391 6.91269 5.90039 6.00277"
      stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
    <path
      d="M7.5 19C8.15503 20.7478 9.92246 22 12 22C12.2445 22 12.4847 21.9827 12.7192 21.9492M16.5 19C16.2329 19.7126 15.781 20.3428 15.1985 20.8393"
      stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
  </g>
`;

const svgbing = document.createElementNS(SVG_NS, "svg");
svgbing.setAttribute("viewBox", "0 0 24 24");
svgbing.setAttribute("fill", "none");
svgbing.setAttribute("width", "24");
svgbing.setAttribute("height", "24");

svgbing.innerHTML = `
 <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
           <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
           <g id="SVGRepo_iconCarrier">
             <path d="M10 9H14L10 13H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
               stroke-linejoin="round">
             </path>
             <path
               d="M7.5 19C8.15503 20.7478 9.92246 22 12 22C12.2445 22 12.4847 21.9827 12.7192 21.9492M16.5 19C16.2329 19.7126 15.781 20.3428 15.1985 20.8393"
               stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
             <path
               d="M9.10745 2.67414C9.98414 2.24187 10.9649 2 12 2C15.7274 2 18.7491 5.13623 18.7491 9.00497V9.70957C18.7491 10.5552 18.9903 11.3818 19.4422 12.0854L20.5496 13.8095C21.5612 15.3843 20.789 17.5249 19.0296 18.0229C14.4273 19.3257 9.57274 19.3257 4.97036 18.0229C3.21105 17.5249 2.43882 15.3843 3.45036 13.8095L4.5578 12.0854C5.00972 11.3818 5.25087 10.5552 5.25087 9.70957V9.00497C5.25087 7.93058 5.48391 6.91269 5.90039 6.00277"
               stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
           </g>
`;

const svgoff = document.createElementNS(SVG_NS, "svg");
svgoff.setAttribute("viewBox", "0 0 24 24");
svgoff.setAttribute("fill", "none");
svgoff.setAttribute("width", "24");
svgoff.setAttribute("height", "24");

svgoff.innerHTML = `
<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
           <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
           <g id="SVGRepo_iconCarrier">
             <path d="M10 9H14L10 13H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
               stroke-linejoin="round">
             </path>
             <path
               d="M7.5 19C8.15503 20.7478 9.92246 22 12 22C12.2445 22 12.4847 21.9827 12.7192 21.9492M16.5 19C16.2329 19.7126 15.781 20.3428 15.1985 20.8393"
               stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
             <path
               d="M9.10745 2.67414C9.98414 2.24187 10.9649 2 12 2C15.7274 2 18.7491 5.13623 18.7491 9.00497V9.70957C18.7491 10.5552 18.9903 11.3818 19.4422 12.0854L20.5496 13.8095C21.5612 15.3843 20.789 17.5249 19.0296 18.0229C14.4273 19.3257 9.57274 19.3257 4.97036 18.0229C3.21105 17.5249 2.43882 15.3843 3.45036 13.8095L4.5578 12.0854C5.00972 11.3818 5.25087 10.5552 5.25087 9.70957V9.00497C5.25087 7.93058 5.48391 6.91269 5.90039 6.00277"
               stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
           </g>
`;

//BUG: there is a subtle bug that does not allow for more
// than one icon to be displayed at a time.
export class McIconBell extends McIcon {
  constructor() {
    super(true);
    this.state = new Map();

    this.state.set("default", svgdefault);
    this.state.set("bing", svgbing);
    this.state.set("off", svgoff);

    this.addHTML(this.template);
  }
}

if (!window.customElements.get("mc-icon-bell"))
  window.customElements.define("mc-icon-bell", McIconBell);
